import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  badgeWrapper: FelaCSS;
}

const styles = (): IStyles => ({
  badgeWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    flexWrap: 'wrap',
    rowGap: 24,
    marginVertical: 2,
  },
});

export default styles;
